import { Checkbox, Input, Textarea } from '@chakra-ui/react';
import { TwDatePicker } from 'components/DatePicker';
import {
  AnotherNumberInput,
  CurrencyNumberInput,
  PercentageNumberInput,
  TwNumberInput,
} from 'components/NumberInput';
import IrrCapPeriodInput from 'components/inputs/IrrCapPeriodInput';
import SelectInput from 'components/inputs/SelectInput';

export const renderInputElement = ({
  item,
  onChange,
  overrideElement,
  styleProps,
  showPrefix,
  isDisabled,
}) => {

  // console.log('renderInputElement', item);

  const Element = overrideElement || item.element;

  let attr = {
    isDisabled: isDisabled || item.isDisabled,
  };

  if (onChange) {
    if (Element === Input || Element === Textarea) {
      attr.onChange = (event) => {
        onChange(item.name, event.target.value);
      };
    } else if (Element === Checkbox) {
      attr.onChange = (event) => {
        onChange(item.name, event.target.checked);
      };
    } else {
      attr.onChange = (value) => {
        onChange(item.name, value);
      };
    }
  }

  return ({ field }) => {
    if (
      Element === TwDatePicker ||
      Element === TwNumberInput ||
      Element === CurrencyNumberInput ||
      Element === PercentageNumberInput ||
      Element === AnotherNumberInput
    ) {
      attr = {
        ...attr,
        inputProps: styleProps,
        showPrefix: showPrefix,
        placeholder: item.placeholder || '',
      };
    }

    if (Element === Input || Element === Textarea) {
      attr = {
        ...attr,
        placeholder: item.placeholder || '',
      };
    }

    if (Element === SelectInput) {
      attr = {
        ...attr,
        value: field.value,
        isNumber: item.isNumber,
        isMulti: item.isMulti,
        options: item.options || [],
        placeholder: item.placeholder || '',
        showValueTooltip: item.showValueTooltip,
      };
    } else if (Element === Checkbox) {
      attr = {
        ...attr,
        isChecked: field.value,
      };
    }

    // IrrCapPeriodInput manages its own layout/widths; do not spread styleProps.w onto it.
    if (Element === IrrCapPeriodInput) {
      return (
        <Element
          value={field.value}
          onBlur={field.onBlur}
          name={field.name}
          ref={field.ref}
          {...attr}
          onPeriodChange={(period) => {
            onChange && onChange('feeSettings.irrCapPeriod', period);
          }}
          {...item.props}
        />
      );
    }

    return <Element {...field} {...attr} {...styleProps} {...item.props} />;
  };
};

export const getFileContent = (file, setFileContent) => {
  if (!file) return null;

  let fileReader = new FileReader();
  fileReader.onload = () => {
    setFileContent(fileReader.result);
  }
  fileReader.readAsArrayBuffer(file);
}